<template>
    <div class="auth-list-wrap">
      <box v-for="(item, key) in show_list_opt_data" :is="box_type(item)" :check_data="right_ids" :key="key" :box_data="item" :ref="item.right_id" @check_change="data_change"></box>
    </div>
</template>

<script>
    import box_1 from "./authList/authList_box_1";
    import box_2 from "./authList/authList_box_2";
    export default {
      props: {
        lang: {},
        auth_list: {}
      },
      components: {
        box_1,
        box_2
      },
      data(){
        return {
          list_opt_data: [
            {right_id: "A0001", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0002", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0003", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0004", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0005", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0006", label: "", entity: ["UK", "GM", "MU", "EU"], current_entity: [], entity_auth_swich: true, check: false},
            {right_id: "A0007", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0008", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0009", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0010", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
            {right_id: "A0011", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false},
          ],
          data_list: [],
          show_list_opt_data: [],
        }
      },
      watch: {
        lang: {
          handler: function (val) {
            this.update_lang();
          },
          deep: true
        }
      },
      methods: {
        init_data() {
          this.update_lang();
          this.add_auth()

        },
        add_auth() {
          this.auth_list.forEach(item => {
            for(let i = 0; i < this.show_list_opt_data.length; i++) {
              if (item.right_id == this.show_list_opt_data[i].right_id) {
                this.show_list_opt_data[i].check = true;
                this.show_list_opt_data[i].current_entity = item.entity;
              }
            }
          });
          this.data_list = JSON.parse(JSON.stringify(this.show_list_opt_data));
        },
        update_lang() {
          this.lang.forEach(item => {
            for (let i = 0; i < this.list_opt_data.length; i++) {
              if (item.right_id == this.list_opt_data[i].right_id) {
                this.list_opt_data[i].label = item.text;
                this.show_list_opt_data.push(this.list_opt_data[i])
              }
            }
          });
          this.data_list = JSON.parse(JSON.stringify(this.show_list_opt_data));
        },
        box_type(item) {
          if (item.entity_auth_swich) {
            return "box_2";
          } else {
            return "box_1";
          }
        },
        update_data(val) {
          for(let i = 0; i < this.show_list_opt_data.length; i++) {
            if (val.right_id == this.data_list[i].right_id) {
              this.show_list_opt_data[i].check = val.check;
              this.show_list_opt_data[i].current_entity = val.entity;
              this.data_list[i].check = val.check;
              this.data_list[i].current_entity = val.entity;
              break;
            }
          }
        },
        data_change(val) {
          this.update_data(val);
        },
        // 全选
        Check_All() {
          this.show_list_opt_data.forEach((item, key) => {
            item.check = true;
            if (item.entity_auth_swich) {
              item.current_entity = item.entity;
            }
          });
          this.data_list = JSON.parse(JSON.stringify(this.show_list_opt_data));
        },
        // 清空
        Clear_All() {
          this.show_list_opt_data.forEach((item, key) => {
            item.check = false;
            if (item.entity_auth_swich) {
              item.current_entity = [];
            }
          });
          this.data_list.forEach((item, key) => {
            item.check = false;
            if (item.entity_auth_swich) {
              item.current_entity = [];
            }
          });
        },
        // 重置数据
        Reset_Data() {
          this.Clear_All();
          // this.init_data();
        },
        // 获取数据
        Get_Data() {
          let _temp = [];
          this.data_list.forEach((item, index) => {
            if (item.check) {
              _temp.push({
                right_id: item.right_id,
                entity: item.current_entity
              })
            }
          });
          return _temp;
        }
      },
      mounted() {
        this.init_data();
      }
    }
</script>

<style lang="scss">
  .auth-list-wrap {
    display: flex;
    flex-direction: column;

    .el-checkbox {
      margin-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// authList.vue?3297914c